/* eslint-disable no-unused-vars */
/* eslint-disable vue/require-prop-type-constructor */
//全局变量,初始化数据
import "@/app/setting"//

import config from "./config"
import api from './api'
import tool from './utils/tool'
import http from "./utils/request"
import {permission, rolePermission} from './utils/permission'


import scEnum from './components/enum'
import scTable from './components/table'
import scTableColumn from './components/table/column.js'
import scFilterBar from './components/filter-bar'
import scUpload from './components/upload'
import scUploadMultiple from './components/upload/multiple'
import scUploadFile from './components/upload/file'
import scFormTable from './components/form-table'
import scTableSelect from './components/table-select'
import scPageHeader from './components/page-header'
import scSelect from './components/select'
import scDialog from './components/dialog/dialog.vue'
import scForm from './components/form'
import scTitle from './components/title'
import scWaterMark from './components/water-mark'
import scQrCode from './components/qrcode'
import tcOmit from './components/table-cells/omit'
import fcSelect from './components/form-cells/select'
import fcAutocomplete from './components/form-cells/autocomplete'
import fcSelectTree from './components/form-cells/select-tree'
import fcSwitch from './components/form-cells/switch'
import iconSelect from './components/icon-select'
import anchor from './components/anchor'

import scStatusIndicator from './components/mini/scStatusIndicator'
import scTrend from './components/mini/scTrend'

import auth from './directives/auth'
import role from './directives/role'
import time from './directives/time'
import copy from './directives/copy'
import borderDrag from "./directives/border-drag"
import errorHandler from './utils/errorHandler'


import * as elIcons from '@element-plus/icons-vue'
import * as scIcons from './assets/icons'
import * as erpIcons from '@/views/erp/support/assets/icon'
import '@/app/authorize.js'

import {defineDatasource} from '@/datasource'
import defaultService from "./datasource/default-service"
defineDatasource('default', defaultService)//默认数据源



import ScProTable from '@/components/pro-table/index'
import AsyncComponent from "@/components/async-component/index.vue";
import BranchNode from '@/components/flow/nodes/branch-node.vue'
import FlowNode from "@/components/flow/nodes/flow-node.vue";
import FlowAction from "@/components/flow/nodes/flow-action.vue";
import SerialNode from "@/components/flow/nodes/serial-node.vue";
import ConditionNode from "@/components/flow/nodes/condition-node.vue";
import IteratorNode from "@/components/flow/nodes/iterator-node.vue";

import loading from '@/config/loading/index.js' //loading组件的简单封装
import {routerLoading} from '@/config/loading/config.js' //全局的页面跳转loading是否启用
import {loadCSS} from '@/utils/load'

// import codemirror from 'vue-codemirror/src/codemirror.vue'
// import '@/components/codemirror/setting.js'
// import 'codemirror/mode/xml/xml.js'

export default {
	install(app) {
		//挂载全局对象
		app.config.globalProperties.$CONFIG = config;
		app.config.globalProperties.$TOOL = tool;
		app.config.globalProperties.$HTTP = http;
		app.config.globalProperties.$API = api;
		app.config.globalProperties.$AUTH = permission;
		app.config.globalProperties.$ROLE = rolePermission;
		app.config.globalProperties.$routerLoading = routerLoading;
		app.config.globalProperties.$loading = loading;

		app.use(ScProTable, {})
		// app.use(initProForm,{})

		//注册全局组件
		app.component('BranchNode', BranchNode);
		app.component('FlowNode', FlowNode);
		app.component('FlowAction', FlowAction);
		app.component('SerialNode', SerialNode);
		app.component('ConditionNode', ConditionNode);
		app.component('IteratorNode', IteratorNode);

		app.component('AsyncComponent', AsyncComponent);

		app.component('scEnum', scEnum);

        app.component('anchor',anchor);
		app.component('scTable', scTable);
		app.component('scTableColumn', scTableColumn);
		app.component('scFilterBar', scFilterBar);
		app.component('scUpload', scUpload);
		app.component('scUploadMultiple', scUploadMultiple);
		app.component('scUploadFile', scUploadFile);
		app.component('scFormTable', scFormTable);
		app.component('scTableSelect', scTableSelect);
		app.component('scPageHeader', scPageHeader);
		app.component('scSelect', scSelect);
		app.component('scDialog', scDialog);
		app.component('scForm', scForm);
		app.component('scTitle', scTitle);
		app.component('scWaterMark', scWaterMark);
		app.component('scQrCode', scQrCode);
		app.component('tcOmit', tcOmit);
		app.component('iconSelect', iconSelect);
		app.component('fcSelect', fcSelect);
		app.component('fcAutocomplete',fcAutocomplete);
		app.component('fcSelectTree',fcSelectTree);
		app.component('fcSwitch',fcSwitch);
		app.component('scStatusIndicator', scStatusIndicator);
		app.component('scTrend', scTrend);
		// app.component('codemirror',codemirror);
		//注册全局指令
		app.directive('auth', auth)
		app.directive('role', role)
		app.directive('time', time)
		app.directive('copy', copy)
		app.directive('border-drag', borderDrag)
		// console.log(elIcons)
		//统一注册el-icon图标
		for (let icon in elIcons) {

			app.component(`ElIcon${icon}`, elIcons[icon])
		}
		//统一注册sc-icon图标
		for (let icon in scIcons) {
			app.component(`ScIcon${icon}`, scIcons[icon])
		}
		//统一注册erp系统的sc-icon图标
		for (let icon in erpIcons) {
			app.component(`ScIcon${icon}`, erpIcons[icon])
		}

		//关闭async-validator全局控制台警告
		window.ASYNC_VALIDATOR_NO_WARNING = 1

		//全局代码错误捕捉
		app.config.errorHandler = errorHandler

		loadCSS('/font-awesome/css/font-awesome.min.css','font-awesome')
	}
}
